import {
	DANGER_COLOR,
	DARK_TEXT_COLOR,
	DISABLED_COLOR,
	FULL_SLOT,
	MAIN_COLOR,
	MAIN_HOVER_COLOR,
	TEXT_COLOR,
  TEXT_COLOR_OPACITY,
} from 'shared/consts/styleValues';
import { TColorText } from 'shared/types';
import styled, { css } from 'styled-components';

interface Button {
	$isFullWidth?: boolean;
	$padding?: string;
	$background?: string | false;
	$color?: TColorText;
	$hover?: boolean;
	$disabled?: boolean;
	$borderColor?: string;
  $pen?: boolean;
}

const getColor = (type: TColorText = 'default') => {
	switch (type) {
		case 'main':
			return MAIN_COLOR;
		case 'danger':
			return FULL_SLOT;
		case 'basic':
			return TEXT_COLOR;
		case 'disabled':
			return TEXT_COLOR_OPACITY;
		default:
			return 'white';
	}
};

export const Button = styled.button<Button>`
	background-color: ${props => props.$background || MAIN_COLOR};
	padding: ${props => props.$padding || '8px'};
	color: ${props => getColor(props.$color)};
	border-radius: 48px;
	border-color: ${props => props.$borderColor};
	position: relative;

	@media screen and (max-width: 768px){
		font-size: 16px;
	}

	${props =>
		props.$isFullWidth &&
		css`
			width: 100%;
		`}

	${props =>
		props.$hover &&
		!props.$disabled &&
		css`
			&:hover {
				background-color: ${MAIN_HOVER_COLOR};
				color: ${DARK_TEXT_COLOR};
			}
		`};

	${props =>
		props.$disabled &&
		css`
			background-color: ${DISABLED_COLOR};
			color: ${DARK_TEXT_COLOR};
      pointer-events: none;
		`};

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;

  ${props => props.$pen && css`pointer-events: none;`}
`;


export const Tag = styled.span`
	width: 16px;
	height: 16px;
	border-radius: 100px;
	background: ${DANGER_COLOR};
	display: flex;
	position: absolute;
	right: -2px;
	top: -2px;
`;